import { AudioPlayer } from '@ibsys/kit';
import { FC } from 'react';
import { useDialogAudioState } from '@/entities/conversations';
import { DialogSession } from './DialogSession';

type Props = {
  /** Id of the conversation/dialog; when undefined, only AudioPlayer is provided (no session context). */
  dialogId?: string;
  children: React.ReactNode;
};

/**
 * Root that composes AudioPlayer and DialogSession.
 * Does not provide context; the context lives inside DialogSession.
 */
export const DialogSessionRoot: FC<Props> = ({ dialogId, children }) => {
  const { status: audioStatus, audioUrl, retryRecordingFetch } = useDialogAudioState(dialogId);

  return (
    <AudioPlayer src={audioUrl}>
      {dialogId ? (
        <DialogSession dialogId={dialogId} audioStatus={audioStatus} retryRecordingFetch={retryRecordingFetch}>
          {children}
        </DialogSession>
      ) : (
        children
      )}
    </AudioPlayer>
  );
};
